import React, { useState } from "react";
import "./Tabs.css";

const GeneralRules = () => {
  const [activeTab, setActiveTab] = useState("organization");

  return (
    <div className="rules-container">
      <h1 className="rules-title">general rules</h1>

      {/* Navigation Tabs */}
      <div className="rules-tabs">
        <button
          className={`tab ${activeTab === "organization" ? "active" : ""}`}
          onClick={() => setActiveTab("organization")}
        >
          ORGANIZATION
        </button>
        <button
          className={`tab ${activeTab === "participants" ? "active" : ""}`}
          onClick={() => setActiveTab("participants")}
        >
          PARTICIPANTS
        </button>
        <button
          className={`tab ${activeTab === "registration" ? "active" : ""}`}
          onClick={() => setActiveTab("registration")}
        >
          THE REGISTRATION FEE
        </button>
      </div>

      {/* Content */}
      <div className="rules-content">
        {activeTab === "organization" && (
          <div className="content">
            <img
              src="./gallery/VLD_8742.jpg"
              alt="Offroad"
              className="content-image"
              loading="lazy"
            />
            <p>
              SERBIAN TROPHY is an offroad competition organized by the SERBIA
              4×4 Off-road team. The competition is divided into three
              categories (classes): TROPHY, ADVENTURE, and TOURIST (revision
              class). All necessary information, radar book, referees, rulebook
              and everything else necessary for this event is provided by the
              organizer. The organizer reserves the right to change the hourly
              schedule provided in the invitation letter, as well as to change
              the rulebook in case of unexpected events.
            </p>
          </div>
        )}
        {activeTab === "participants" && (
          <div className="content">
            <img
              src="./gallery/VLD_10019.jpg"
              alt="Offroad"
              className="content-image"
              loading="lazy"
            />
            <p>
              SERBIAN TROPHY is open to anyone interested in a capable off-road
              vehicle. Each vehicle in the TROPHY and ADVENTURE classes must
              have two crew members, drivers and co-drivers. Both driver and
              front passenger must have a valid driver’s license. Vehicles in
              the TURIST class can have an arbitrary number of members, up to
              the maximum number of passengers registered. Before the start of
              the competition, the team must complete the application form and
              pay the registration fee specified by the organizer.
            </p>
          </div>
        )}
        {activeTab === "registration" && (
          <div className="content">
            <img
              src="./gallery/VLD_8834.jpg"
              alt="Offroad"
              className="content-image"
              loading="lazy"
            />
            <p>
              The registration fee is paid per participant, before the start of
              the competition and is 250EU per person. It covers participants’
              accommodation and food, as well as certain propaganda material.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default GeneralRules;
